// extracted by mini-css-extract-plugin
module.exports = {"native":"_1s14f","label":"_1eqzm"};